import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface FaqItemProps {
  question: string;
  answer: string;
}

const FaqItem: React.FC<FaqItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 last:border-b-0">
      <button
        className="w-full text-left py-4 px-2 flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-100 rounded"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="font-medium">{question}</span>
        {isOpen ? (
          <ChevronUp className="flex-shrink-0 text-gray-500" size={20} />
        ) : (
          <ChevronDown className="flex-shrink-0 text-gray-500" size={20} />
        )}
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 pb-4 px-2' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-gray-700">{answer}</p>
      </div>
    </div>
  );
};

interface FaqAccordionProps {
  faqs: FaqItemProps[];
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({ faqs }) => {
  return (
    <div className="divide-y divide-gray-200">
      {faqs.map((faq, index) => (
        <FaqItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

export default FaqAccordion;